<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Se connecter</div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList">
        <span v-if="errorMsgList.errorLogin">
          - <a href="#" @click="passwordReset">Cliquez ici</a> pour ré-initialiser votre mot de passe
          <br />
        </span>
      </app-error-msg>

      <!-- <form @submit.prevent="login"> -->
      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputEmail" label="Email" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="email"
                   placeholder="Entrez votre email" @keyup-enter="nextInput('inputPassword')"></app-input>

        <app-label input-id="inputPassword" label="Mot de passe" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputPassword" ref="inputPassword" input-type="password" v-model="password"
                   placeholder="Entrez votre mot de passe" @keyup-enter="login"></app-input>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <p>
          <a href="#" @click="passwordReset">J'ai oublié mon mot de passe</a>
        </p>
        <v-ons-button modifier="large--cta perflarge" @click="login" :disabled="! (email && password)">
          Se connecter
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';
import AppLoginPassword from './LoginPassword.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    async login(event) {
      if(this.isSubmit || ! (this.email && this.password)){
        return;
      }
      this.closeKeyboard(event);
      this.resetErrorMsgList();

      this.isSubmit = true;

      this.email = this.email.replace(/ /g, '');

      const fd = new FormData();
      fd.append('email', this.email);
      fd.append('password', this.password);
      const pushToken = localStorage.getItem('push_token');
      if (pushToken) {
        fd.append('push_token', pushToken);
      }

      const fetchInit = this.$getFetchInit('POST', true);
      fetchInit.body = fd;
      const callPath = this.$apiDomain + '/login';
      await this.handleLogin(fetchInit, callPath);
    },
    passwordReset() {
      this.resetErrorMsgList();
      var email = this.email;
      this.pageStack.push({
        extends: AppLoginPassword,
        data() {
          return {
            email: email
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.footer--perfbutton > p {
  margin: -20px 0 30px;
}
</style>